var map = {
	"./Accepted.svg": "./src/assets/images/Accepted.svg",
	"./Acknowledged.svg": "./src/assets/images/Acknowledged.svg",
	"./CircleNotification.svg": "./src/assets/images/CircleNotification.svg",
	"./ContractOutgoingBIG.svg": "./src/assets/images/ContractOutgoingBIG.svg",
	"./Document.svg": "./src/assets/images/Document.svg",
	"./Draft.svg": "./src/assets/images/Draft.svg",
	"./IRN_Done.svg": "./src/assets/images/IRN_Done.svg",
	"./IRN_Errors.svg": "./src/assets/images/IRN_Errors.svg",
	"./InviteUser.svg": "./src/assets/images/InviteUser.svg",
	"./Invited.svg": "./src/assets/images/Invited.svg",
	"./InvoiceOutgoingBIG.svg": "./src/assets/images/InvoiceOutgoingBIG.svg",
	"./MAINTAIN 1.svg": "./src/assets/images/MAINTAIN 1.svg",
	"./MAINTAIN 2.svg": "./src/assets/images/MAINTAIN 2.svg",
	"./MAINTAIN 3.svg": "./src/assets/images/MAINTAIN 3.svg",
	"./Manual.svg": "./src/assets/images/Manual.svg",
	"./NoLinksSCM.svg": "./src/assets/images/NoLinksSCM.svg",
	"./POIncomingBIG.svg": "./src/assets/images/POIncomingBIG.svg",
	"./PaymentDueBIG.svg": "./src/assets/images/PaymentDueBIG.svg",
	"./PaymentInitiatedBIG.svg": "./src/assets/images/PaymentInitiatedBIG.svg",
	"./PaymentRecievedBIG.svg": "./src/assets/images/PaymentRecievedBIG.svg",
	"./SubscribedDocuments.svg": "./src/assets/images/SubscribedDocuments.svg",
	"./company.svg": "./src/assets/images/company.svg",
	"./contactSvg.svg": "./src/assets/images/contactSvg.svg",
	"./contractIncoming.svg": "./src/assets/images/contractIncoming.svg",
	"./contractOutgoing.svg": "./src/assets/images/contractOutgoing.svg",
	"./dummy-logo.svg": "./src/assets/images/dummy-logo.svg",
	"./globe.svg": "./src/assets/images/globe.svg",
	"./goods.svg": "./src/assets/images/goods.svg",
	"./graphSvg.svg": "./src/assets/images/graphSvg.svg",
	"./invitationSvg.svg": "./src/assets/images/invitationSvg.svg",
	"./invoiceIncoming.svg": "./src/assets/images/invoiceIncoming.svg",
	"./invoiceOutgoing.svg": "./src/assets/images/invoiceOutgoing.svg",
	"./itemSvg.svg": "./src/assets/images/itemSvg.svg",
	"./loader.svg": "./src/assets/images/loader.svg",
	"./loader2.svg": "./src/assets/images/loader2.svg",
	"./loginProfile.svg": "./src/assets/images/loginProfile.svg",
	"./loginProfile1.svg": "./src/assets/images/loginProfile1.svg",
	"./noAccess.svg": "./src/assets/images/noAccess.svg",
	"./noInvitations.svg": "./src/assets/images/noInvitations.svg",
	"./noTemplates.svg": "./src/assets/images/noTemplates.svg",
	"./noWorkflows.svg": "./src/assets/images/noWorkflows.svg",
	"./paramLogo_01.svg": "./src/assets/images/paramLogo_01.svg",
	"./paramLogo_02.svg": "./src/assets/images/paramLogo_02.svg",
	"./phone.svg": "./src/assets/images/phone.svg",
	"./purchaseOrderIncoming.svg": "./src/assets/images/purchaseOrderIncoming.svg",
	"./purchaseOrderOutgoing.svg": "./src/assets/images/purchaseOrderOutgoing.svg",
	"./purchasesSvg.svg": "./src/assets/images/purchasesSvg.svg",
	"./raw.svg": "./src/assets/images/raw.svg",
	"./received.svg": "./src/assets/images/received.svg",
	"./reconciliationSvg.svg": "./src/assets/images/reconciliationSvg.svg",
	"./reportsSvg.svg": "./src/assets/images/reportsSvg.svg",
	"./salesSvg.svg": "./src/assets/images/salesSvg.svg",
	"./services.svg": "./src/assets/images/services.svg",
	"./workflow.svg": "./src/assets/images/workflow.svg",
	"./workflowBuilder.svg": "./src/assets/images/workflowBuilder.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync \\.(svg)$";